var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSmallColored(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 2627",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iconSmallColored_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2441",
    fill: "none",
    d: "M0 0h80v80H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2626",
    clipPath: "url(#iconSmallColored_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20529",
    d: "M40 0A40 40 0 110 40 40 40 0 0140 0",
    fill: "#e0fff6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20530",
    d: "M40 59.601a19.6 19.6 0 1119.6-19.6 19.623 19.623 0 01-19.6 19.6m0-36.529A16.928 16.928 0 1056.928 40 16.948 16.948 0 0040 23.072",
    fill: "#038258"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20531",
    d: "M40 49.048a9.047 9.047 0 119.047-9.047A9.057 9.057 0 0140 49.048m0-15.42a6.374 6.374 0 106.374 6.374A6.381 6.381 0 0040 33.628",
    fill: "#038258"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmallColored);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/iconSmallColored.53c00297.svg";
export { MemoForwardRef as ReactComponent };